export default [
    {
        path: "/admin/basic-salarys",
        name: "basic-salary",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/basic-salary/index.vue")
    }
];
